class ConsumeFailParamDto {
  /** consumerException */
  consumerException = "";

  /** groupId */
  groupId = "";

  /** localMessageId */
  localMessageId = "";

  /** messageId */
  messageId = "";

  /** traceId */
  traceId = "";
}

class ConsumeParamDto {
  /** consumerAppHost */
  consumerAppHost = "";

  /** consumerAppName */
  consumerAppName = "";

  /** consumerException */
  consumerException = "";

  /** consumerStatus */
  consumerStatus = "FAIL";

  /** consumerTime */
  consumerTime = "";

  /** groupId */
  groupId = "";

  /** localMessageId */
  localMessageId = "";

  /** message */
  message = "";

  /** messageId */
  messageId = "";

  /** tags */
  tags = "";

  /** topic */
  topic = "";

  /** traceId */
  traceId = "";
}

class MessageLogResultDto {
  /** 业务KEY */
  businessKey = "";

  /** 业务用户 */
  businessUser = "";

  /** 消费者-应用地址 */
  consumerAppHost = "";

  /** 消费者-应用名称 */
  consumerAppName = "";

  /** 消费异常 */
  consumerException = "";

  /** 消费次数 */
  consumerNumber = "";

  /** 消费状态 */
  consumerStatus = "FAIL";

  /** 消费时间 */
  consumerTime = "";

  /** 创建时间 */
  createTime = "";

  /** 组ID */
  groupId = "";

  /** id */
  id = "";

  /** 本地消息ID */
  localMessageId = "";

  /** 消息内容 */
  message = "";

  /** 消息ID */
  messageId = "";

  /** 生产者-应用地址 */
  producerAppHost = "";

  /** 生产者-应用名称 */
  producerAppName = "";

  /** 生产异常 */
  producerException = "";

  /** 生产次数 */
  producerNumber = "";

  /** 推送状态 */
  producerStatus = "FAIL";

  /** 推送时间 */
  producerTime = "";

  /** 标签 */
  tags = "";

  /** 主题 */
  topic = "";

  /** 链路日志ID */
  traceId = "";

  /** 修改时间 */
  updateTime = "";
}

class OperationCommonLogDto {
  /** businessNo */
  businessNo = "";

  /** businessType */
  businessType = "";

  /** createTime */
  createTime = "";

  /** creator */
  creator = "";

  /** currentApplication */
  currentApplication = "";

  /** errorMessage */
  errorMessage = "";

  /** id */
  id = "";

  /** operationDesc */
  operationDesc = "";

  /** operationInfo */
  operationInfo = "";

  /** operationName */
  operationName = "";

  /** operationType */
  operationType = "";

  /** sourceApplication */
  sourceApplication = "";

  /** traceId */
  traceId = "";

  /** updateTime */
  updateTime = "";

  /** updater */
  updater = "";
}

class OperationLogParamDto {
  /** businessNo */
  businessNo = "";

  /** businessType */
  businessType = "";

  /** currentApplication */
  currentApplication = "";

  /** errorMessage */
  errorMessage = "";

  /** operationDesc */
  operationDesc = "";

  /** operationInfo */
  operationInfo = "";

  /** operationName */
  operationName = "";

  /** operationType */
  operationType = "";

  /** sourceApplication */
  sourceApplication = "";

  /** traceId */
  traceId = "";
}

class OperationLogResultDto {
  /** businessNo */
  businessNo = "";

  /** businessType */
  businessType = "";

  /** createTime */
  createTime = "";

  /** creator */
  creator = "";

  /** currentApplication */
  currentApplication = "";

  /** errorMessage */
  errorMessage = "";

  /** id */
  id = "";

  /** operationDesc */
  operationDesc = "";

  /** operationName */
  operationName = "";

  /** operationType */
  operationType = "";

  /** sourceApplication */
  sourceApplication = "";

  /** traceId */
  traceId = "";

  /** updateTime */
  updateTime = "";

  /** updater */
  updater = "";
}

class PageInfoResponeDto {
  /** current */
  current = undefined;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class Response {
  /** code */
  code = "";

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new OperationLogResultDto();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class SaveOperationParamDto {
  /** businessNo */
  businessNo = "";

  /** businessType */
  businessType = "";

  /** createTime */
  createTime = "";

  /** creator */
  creator = "";

  /** currentApplication */
  currentApplication = "";

  /** errorMessage */
  errorMessage = "";

  /** id */
  id = "";

  /** operationDesc */
  operationDesc = "";

  /** operationInfo */
  operationInfo = "";

  /** operationName */
  operationName = "";

  /** operationType */
  operationType = "";

  /** sourceApplication */
  sourceApplication = "";

  /** traceId */
  traceId = "";

  /** updateTime */
  updateTime = "";

  /** updater */
  updater = "";
}

class SendFailParamDto {
  /** groupId */
  groupId = "";

  /** localMessageId */
  localMessageId = "";

  /** messageId */
  messageId = "";

  /** producerException */
  producerException = "";

  /** traceId */
  traceId = "";
}

class SendParamDto {
  /** body */
  body = "";

  /** businessKey */
  businessKey = "";

  /** businessUser */
  businessUser = "";

  /** groupId */
  groupId = "";

  /** localMessageId */
  localMessageId = "";

  /** message */
  message = "";

  /** messageId */
  messageId = "";

  /** messageType */
  messageType = "COMMON_MESSAGE";

  /** messageTypeObj */
  messageTypeObj = undefined;

  /** producerAppHost */
  producerAppHost = "";

  /** producerAppName */
  producerAppName = "";

  /** producerException */
  producerException = "";

  /** producerStatus */
  producerStatus = "FAIL";

  /** producerTime */
  producerTime = "";

  /** tags */
  tags = "";

  /** topic */
  topic = "";

  /** traceId */
  traceId = "";
}

export const aider = {
  ConsumeFailParamDto,
  ConsumeParamDto,
  MessageLogResultDto,
  OperationCommonLogDto,
  OperationLogParamDto,
  OperationLogResultDto,
  PageInfoResponeDto,
  Response,
  ResponseDto,
  SaveOperationParamDto,
  SendFailParamDto,
  SendParamDto,
};
